"use client";

import { MapPin, Gift, Lock, Zap, Shield, BarChart3 } from "lucide-react";

const features = [
  {
    icon: MapPin,
    title: "Location-Based Adventures",
    description: "Create immersive experiences tied to real-world locations using NFC chip technology."
  },
  {
    icon: Gift,
    title: "Digital Asset Rewards",
    description: "Mint unique blockchain-based rewards that participants can collect, trade, and showcase."
  },
  {
    icon: Lock,
    title: "Digital Asset Gating",
    description: "Gate campaigns and rewards behind digital asset ownership — require participants to hold specific assets before unlocking exclusive content or claims."
  },
  {
    icon: Zap,
    title: "Instant Setup",
    description: "Launch immersive digital asset experiences in hours, after obtaining your IYK NFC chips."
  },
  {
    icon: Shield,
    title: "3rd Party Integrations",
    description: "Connect with Luma, Meetup, Mailchimp, and more to power your campaigns and streamline your workflows."
  },
  {
    icon: BarChart3,
    title: "Advanced Analytics",
    description: "Track participation, engagement metrics, and ROI with detailed reporting dashboards."
  }
];

export function ServiceDescription() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Everything You Need to Create
            <span className="text-blue-600"> Amazing Experiences</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Our platform combines gamification and participation incentivization with cutting-edge technology 
            to deliver unforgettable interactive experiences for any audience.
          </p>
        </div>

        {/* Features grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="group p-8 rounded-2xl border border-gray-100 hover:border-blue-200 hover:shadow-lg transition-all duration-300"
            >
              <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-6 group-hover:bg-blue-600 transition-colors duration-300">
                <feature.icon className="w-6 h-6 text-blue-600 group-hover:text-white transition-colors duration-300" />
              </div>
              
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {feature.title}
              </h3>
              
              <p className="text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>


      </div>
    </section>
  );
}
